module.exports = __webpack_public_path__ + "assets/img/sam_simon-8d923aef.jpg";